import PropTypes from 'prop-types';
import cn from 'classnames';
import React from 'react';
import { CircularProgress } from '@mui/material';
import styles from './Buttons.module.css';
import Button from '../../Button/Button';

function ButtonClassic({
  onClick,
  children,
  loading = false,
  disabled = false,
  className = undefined,
}) {
  return (
    <Button
      type="submit"
      variant="contained"
      color="blue"
      className={cn(styles.submitButton, className)}
      onClick={onClick}
      disabled={loading || disabled}
    >
      {loading ? (
        <CircularProgress className={styles.circularLoading} />
      ) : (
        children
      )}
    </Button>
  );
}

ButtonClassic.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

function ActionButton({
  onClick = () => {},
  disabled = false,
  children,
  destructive = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.actionButton} ${
        destructive ? styles.destructiveButton : ''
      }`}
    >
      {children}
    </button>
  );
}

ActionButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  destructive: PropTypes.bool,
};

function ConfirmationButton({
  onClick = () => {},
  disabled = false,
  children,
  destructive = false,
}) {
  return (
    <Button
      type="button"
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.actionButton} ${
        destructive ? styles.destructiveButton : ''
      }`}
      small
    >
      {children}
    </Button>
  );
}

ConfirmationButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  destructive: PropTypes.bool,
};

function SecondaryButton({
  onClick = () => {},
  disabled = false,
  children,
  destructive = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.secondaryButton} ${
        destructive ? styles.destructiveButton : ''
      }`}
    >
      {children}
    </button>
  );
}

SecondaryButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  destructive: PropTypes.bool,
};

export { ButtonClassic, ActionButton, ConfirmationButton, SecondaryButton };
